export default "__VITE_ASSET__7Lk0xQ8v__"